import { ajaxSign } from './sign'
export interface AjaxOptions {
	action: string
	data?: object
	headers?: object
	withCredentials?: boolean
	filename: string
	onError: (error: any) => void
	onSuccess: (response: any) => void
	onProgress: (proObj) => void
}
function getBody(xhr) {
	const text = xhr.responseText || xhr.response
	if (!text) {
		return text
	}

	try {
		return JSON.parse(text)
	} catch (e) {
		return text
	}
}
export const ajax = (option: AjaxOptions) => {
	if (typeof XMLHttpRequest === 'undefined') {
		return
	}

	const xhr = new XMLHttpRequest()

	const action = option.action
	xhr.responseType = 'blob'
	xhr.onerror = function error(e) {
		option.onError(e)
	}

	xhr.onprogress = function progress(e) {
		if (e.lengthComputable) {
			const percentComplete = Math.round((e.loaded / e.total) * 100)
			option.onProgress({
				percent: percentComplete,
				loaded: e.loaded,
				total: e.total
			})
		}
	}

	xhr.onload = function onload() {
		if (xhr.status < 200 || xhr.status >= 300) {
			return option.onError('response' in xhr ? xhr.response : getBody(xhr))
		}

		option.onSuccess('response' in xhr ? xhr.response : getBody(xhr))
	}

	xhr.open('post', action, true)
	xhr.setRequestHeader('content-type', 'application/json; charset=UTF-8')

	if (option.withCredentials && 'withCredentials' in xhr) {
		xhr.withCredentials = true
	}

	const headers = option.headers || {}

	for (const item in headers) {
		if (Object.prototype.hasOwnProperty.call(headers, item) && headers[item] !== null) {
			xhr.setRequestHeader(item, headers[item])
		}
	}

	const data: any = option.data || {}
	data.filename = option.filename

	ajaxSign(action, data, xhr)

	xhr.send(JSON.stringify(data))
	return xhr
}
